import { atom } from 'jotai'

export const routeCacheAtom = atom<Record<string, string>>({})
